import React from 'react';
import PropTypes from 'prop-types';

import s from './Profile.css';


const LoginInfo = ({ username, updateValue }) =>
  <section className={s.component}>
    <h3 className={s.header}>
      Login Information
    </h3>
    <div className={s.group}>
      <label className={s.label} htmlFor="username">
        Username
      </label>
      <div className={s.controlContainer}>
        <input
          id="username"
          name="username"
          className={s.control}
          type="text"
          value={username}
          placeholder="Type Username..."
          onChange={event => updateValue("username", event.target.value)}
          required
        />
      </div>
    </div>
  </section>;

LoginInfo.propTypes = {
  username: PropTypes.string,
  updateValue: PropTypes.func,
};

export default LoginInfo;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/Profile/LoginInfo.js